var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPonylinkDarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238,
    height: 49,
    viewBox: "0 0 238 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.718 25.8969V9.33765H171.282V29.7336C171.282 31.9174 169.691 32.6742 169.691 32.6742C171.332 32.6742 171.935 32.0718 171.935 32.0718C172.008 32.0115 177.792 28.0807 177.792 28.0807C178.43 27.5611 178.722 26.7215 178.722 25.8969H178.718Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.595 7.21411V0.00756836L171.243 7.21035H178.595V7.21411Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.393 28.2049L145.278 32.0303C145.374 32.1132 145.977 32.6102 147.244 32.6667H165.916C167.652 32.6667 169.061 31.2848 169.061 29.583V25.8027H145.931V0H138.349V25.735C138.349 26.6574 138.721 27.5423 139.386 28.1899L139.397 28.2012L139.393 28.2049Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.503 32.678L210.537 9.69537C210.537 8.99881 210.43 8.31355 210.199 7.65088C209.957 6.93173 209.585 6.25776 209.101 5.66663L205.34 1.02417C204.676 0.37279 203.773 0.00756836 202.832 0.00756836H180.819V7.21035H202.878L202.844 32.6742H210.499L210.503 32.678Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.673 11.2278V18.103C212.673 18.2084 212.746 18.8109 213.36 19.6166C213.433 19.7597 213.529 19.8877 213.637 19.9931L227.004 32.678H237.997L218.964 14.0178L237.977 0.00756836H226.888L213.775 9.25484C213.076 9.9401 212.688 10.2601 212.688 11.2278H212.677H212.673Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.996 0.00756836H127.729V15.4335H134.996V0.00756836Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.706 0.00756836H103.438V15.4335H110.706V0.00756836Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.984 17.2181L127.701 17.252C127.701 21.8568 123.891 25.5919 119.19 25.5919C114.488 25.5919 110.678 21.8606 110.678 17.252L103.396 17.2181C103.396 24.5188 108.566 30.6335 115.51 32.2638V49H122.85V32.2638C129.795 30.6448 134.965 24.5263 134.965 17.2181H134.976H134.984Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7093 17.252L34.4268 17.2181C34.4268 25.7576 41.4904 32.6892 50.2171 32.6892C58.9439 32.6892 66.0075 25.7689 66.0075 17.2181L58.7249 17.252C58.7249 21.8568 54.9147 25.5919 50.2133 25.5919C45.5119 25.5919 41.7016 21.8606 41.7016 17.252H41.7093Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4043 15.4824L41.6868 15.4486C41.6868 10.8437 45.4971 7.10869 50.1985 7.10869C54.8999 7.10869 58.7102 10.84 58.7102 15.4486L65.9927 15.4824C65.985 6.93173 58.9099 0.00756836 50.1947 0.00756836C41.4794 0.00756836 34.4043 6.92796 34.4043 15.4787V15.4824Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8076 15.4824L76.0902 15.4486C76.0902 10.8437 79.9004 7.10869 84.6018 7.10869C89.3032 7.10869 93.1135 10.84 93.1135 15.4486L100.396 15.4824C100.377 6.93173 93.3132 0.00756836 84.598 0.00756836C75.8827 0.00756836 68.8076 6.92796 68.8076 15.4787V15.4824Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1478 17.2181H68.8076V32.6892H76.1478V17.2181Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.377 17.2181H93.0371V32.6892H100.377V17.2181Z",
    fill: "#252C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29406 30.2344C9.7523 31.7819 12.6715 32.678 15.8057 32.678C24.521 32.678 31.5961 25.7576 31.5961 17.2069L24.3135 17.2408C24.3135 21.8456 20.5033 25.5806 15.8019 25.5806C11.1005 25.5806 7.29022 21.8494 7.29022 17.2408V15.4335C7.29022 10.8287 11.1005 7.09363 15.8019 7.09363C20.5033 7.09363 24.3135 10.8249 24.3135 15.4335L31.5961 15.4674C31.5961 6.93173 24.5171 0.00756836 15.8019 0.00756836C7.08665 0.00756836 0.157481 6.79995 0.023046 15.2339H0V48.9887H7.29406V30.2344Z",
    fill: "#252C6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPonylinkDarkLogo);
export default __webpack_public_path__ + "static/media/ponylink-dark-logo.ddbcc616380ab67028859746926b0c64.svg";
export { ForwardRef as ReactComponent };